/**
 * Applies some default styles
 */
import React from 'react'
import styled from 'styled-components'

const DefaultStyles = styled.div`
  color: ${({ theme }) => theme.primary};
  background-color: ${({ theme }) => theme.background};
  h1 {
    ${({ theme }) => theme.textStyleH1}
  }
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`
const Layout = ({ children }: { children: React.ReactNode }) => {
  return <DefaultStyles>{children}</DefaultStyles>
}
export default Layout
